'use client';

import React from 'react';
import NewsAndEventsSection from '@/components/organisms/new-and-events';

const NewsAndEventsTastic = ({ data }: any) => {

  return (
    <>
      <NewsAndEventsSection data={data?.data?.dataSource} />
    </>
  )
};

export default NewsAndEventsTastic;